module.exports = __webpack_public_path__ + "img/biodata.6c8f06eb.svg";